import React from "react";

/**
 * Premium console-style menu button.
 * Slow neon pulse glow, smooth hover intensification, soft sweeping shimmer.
 * No flicker spam.
 */
const GameMenuButton = React.forwardRef(
  ({ children, hint, variant = "cyan", onClick, ...props }, ref) => {
    const palette =
      variant === "pink"
        ? {
            border: "border-[#FF007A]/70",
            text: "text-[#FF007A]",
            pulse: "menu-pulse-pink",
            hintText: "text-[#FF007A]/70",
          }
        : {
            border: "border-[#00F0FF]/70",
            text: "text-[#00F0FF]",
            pulse: "menu-pulse-cyan",
            hintText: "text-[#00F0FF]/70",
          };

    return (
      <button
        ref={ref}
        onClick={onClick}
        className={`group menu-btn ${palette.pulse} relative w-full sm:w-[22rem] ${palette.text} bg-[#0A0510]/55 border ${palette.border} px-7 py-5 sm:py-6 text-left`}
        {...props}
      >
        <div className="relative flex items-center justify-between gap-6">
          <div className="flex items-center gap-5">
            <span
              aria-hidden="true"
              className="inline-block text-base sm:text-lg transition-transform duration-500 group-hover:translate-x-1"
            >
              ▶
            </span>
            <div className="flex flex-col">
              <span className="font-display text-lg sm:text-2xl font-bold tracking-[0.18em] uppercase leading-none">
                {children}
              </span>
              {hint ? (
                <span
                  className={`mt-2 font-mono text-[9px] sm:text-[10px] uppercase tracking-[0.36em] ${palette.hintText}`}
                >
                  {hint}
                </span>
              ) : null}
            </div>
          </div>
          <span
            aria-hidden="true"
            className={`inline-block h-1.5 w-1.5 rounded-full ${variant === "pink" ? "bg-[#FF007A]" : "bg-[#00F0FF]"} transition-all duration-500 group-hover:scale-150`}
            style={{
              boxShadow:
                variant === "pink"
                  ? "0 0 10px #FF007A, 0 0 20px #FF007A"
                  : "0 0 10px #00F0FF, 0 0 20px #00F0FF",
            }}
          />
        </div>
      </button>
    );
  }
);
GameMenuButton.displayName = "GameMenuButton";

export default GameMenuButton;
